import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/Home';
import ConnectPage from './pages/Connect';
import QuestionPage from './pages/Question';
import LecturePage from './pages/Lecture';
import SubscriptionPage from './pages/Subscription';
import QuestionView from './pages/QuestionView';
import FlashcardView from './pages/FlashcardView';
import AlgospotView from './pages/AlgospotView';
import RandomFlashcard from './pages/RandomFlashcard';
import RandomAlgospot from './pages/RandomAlgospot';
import TrainerPage from './pages/Trainer';
import MentorPage from './pages/Mentor';
import TopicsPage from './pages/Topics';
import AppShell from './components/AppShell';

export default function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/connect" element={<ConnectPage />} />
        <Route path="/question" element={<QuestionPage />} />
        <Route path="/question/:id" element={<QuestionView />} />
        <Route path="/flashcard" element={<RandomFlashcard />} />
        <Route path="/flashcard/:id" element={<FlashcardView />} />
        <Route path="/algospot" element={<RandomAlgospot />} />
        <Route path="/algospot/:id" element={<AlgospotView />} />
        <Route path="/lecture/:id" element={<LecturePage />} />
        <Route path="/subscription" element={<SubscriptionPage />} />
        <Route path="/trainer" element={<TrainerPage />} />
        <Route path="/mentor" element={<MentorPage />} />
        <Route path="/topics" element={<TopicsPage />} />
        <Route path="/topics/:examId" element={<TopicsPage />} />
        <Route path="/topics/:examId/:branchId" element={<TopicsPage />} />
        <Route path="/topics/:examId/:branchId/:topicId" element={<TopicsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
